import { FC, useEffect, useRef, useState } from 'react';
import { Client, IWizForm, Provider } from '../../../helpers/models';
import moment from 'moment';
import { isDateLessThanDaysOld } from '../../../helpers/funcs';
import { WizFormViewer } from './WizFormViewer';
import { useReactToPrint } from 'react-to-print';

type Props = {
  form: IWizForm;
};

const FormCard: FC<Props> = (props) => {
  const form = props.form;
  const [expanded, setExpanded] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  return (
    <>
      <style>{`
        @media print {
          .wiz-print-page {
            padding-left: 0.75in !important;
            padding-right: 0.75in !important;
            box-shadow: none !important;
            margin-top: 0 !important;
            margin-bottom: 0 !important;
          }
          .no-print { display: none !important; }
          .form-preview-overlay { display: none !important; }
          .form-preview-collapsed { max-height: none !important; overflow: visible !important; }
          .mt-auto { margin-top: 0 !important; }
          .mb-5 { margin-bottom: 0 !important; }
          .card { break-inside: avoid; page-break-inside: avoid; }
        }
      `}</style>
      <div className="card shadow-sm mt-auto mb-5 wiz-print-page" key={form.uuid} data-uuid={form.uuid} ref={contentRef}>
        <div className="card-header mobile-header">
          <h3 className="card-title">{form.form_template_display_name}</h3>
          <div className="card-toolbar">
            <span className="me-4 pt-1">{moment(form.complete_date).format('LLL')}</span>
            <button className="btn btn-outline btn-outline-primary btn-sm no-print" onClick={() => reactToPrintFn()}>
              Print
            </button>
          </div>
        </div>
        <div className="card-body position-relative">
          <div
            className={expanded ? '' : 'form-preview-collapsed'}
            style={expanded ? undefined : { maxHeight: '160px', overflow: 'hidden' }}
          >
            <WizFormViewer form={form} />
          </div>
          {!expanded && (
            <div
              className="form-preview-overlay position-absolute start-0 end-0"
              style={{
                bottom: 0,
                height: '96px',
                pointerEvents: 'none',
                background: 'linear-gradient(to bottom, rgba(255,255,255,0), var(--bs-card-bg, #ffffff))',
              }}
            />
          )}
        </div>
        <div className="card-footer d-flex justify-content-between align-items-center no-print">
          <div className="text-muted">
            <div className="row">Submitted: {moment(form.complete_date).format('LLL')}</div>
            <div className="row">IP Address: {form.ip_address}</div>
          </div>
          <div>
            <button
              className="btn btn-outline btn-outline-primary btn-sm"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? 'Show less' : 'Show more'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export { FormCard };
